<template>
  <Layout1 title="Recover your account">
    <template slot="form">
      <div class="h-100">
        <div class="h-100 d-flex justify-center">
              <v-layout row>
                    <div v-if="showVerifyEmail">
                      <div class="form-floating mb15">
                        <input
                          type="email"
                          id="email"
                          name="email"
                          v-model="form.email"
                          placeholder="Email"
                          class="form-control fn14"
                          v-validate="'required|email'"
                        />
                        <label for="email">Enter your email</label>
                        <small class="col_error" v-show="errors.has('email')">{{ errors.first('email') }}</small>
                      </div>

                      <vue-recaptcha class="mt-2"
                        ref="recaptcha"
                        @verify="onCaptchaVerified"
                        @expired="onCaptchaExpired"
                        :sitekey="siteKey">
                      </vue-recaptcha>

                      <v-card-actions class="mt-4 p-0">
                        <button class="btn btn-apiculus-primary mr-2" :disabled="!(fields.email && fields.email.valid && form['g-recaptcha-response'])" @click="sendVerificationLink">START RECOVERY PROCESS</button>
                        <router-link class="col_primary" to="/">CANCEL</router-link>  
                      </v-card-actions>
                    </div>

                    <div v-if="showEmailOTP">
                      <div class="p10">
                        <h6 class="emailText">A one-time password (OTP) has been sent to your email address. To verify ownership, enter the OTP as received.</h6>
                        <div class="form-floating mb15">
                          <input
                            placeholder="Enter Email OTP"
                            v-model="emailOtp"
                            v-validate="'required'"
                            data-vv-name="otp"
                            :error-messages="errors.collect('otp')"
                            data-vv-validate-on="input|blur|update|change"
                            id="otp"
                            name="otp"
                            class="form-control fn14"
                          />
                          <label for="emailOtp">Enter Email OTP</label>
                          <small class="col_error" v-show="errors.has('otp')">{{ errors.first('otp') }}</small>
                        </div>
                      </div>

                      <v-card-actions class="mt-4 p-0">
                        <button class="btn btn-apiculus-primary mr-2" :disabled="!(emailOtp && emailOtp.length)" @click="validateEmailOTP">NEXT</button>
                        <router-link class="col_primary" to="/">CANCEL</router-link>  
                      </v-card-actions>
                    </div>

                    <div v-if="showMobileOtp">
                      <div class="p10">
                        <h6 class="emailText">A one-time password (OTP) has been sent to your registered mobile <b>+{{countryCode}} {{mobileNo}}</b>. To verify ownership, enter the OTP as received.</h6>
                        <div class="form-floating mb15">
                          <input
                            placeholder="Enter Mobile OTP"
                            v-model="mobileOtp"
                            v-validate="'required'"
                            data-vv-name="otp"
                            :error-messages="errors.collect('otp')"
                            data-vv-validate-on="input|blur|update|change"
                            id="otp"
                            name="otp"
                            class="form-control fn14"
                          />
                          <label for="emailOtp">Enter Mobile OTP</label>
                          <small class="col_error" v-show="errors.has('otp')">{{ errors.first('otp') }}</small>
                        </div>
                      </div>

                      <v-card-actions class="mt-4 p-0">
                        <button class="btn btn-apiculus-primary mr-2" :disabled="!(mobileOtp && mobileOtp.length)" @click="validateMobileOTP">NEXT</button>
                        <router-link class="col_primary" to="/">CANCEL</router-link>  
                      </v-card-actions>
                    </div>

                    <div v-if="showSetPassword">
                      <div class="p10">
                        <h6 class="emailText">You're almost done. Choose a new password and make sure you don't use any of your last {{rotation}} used passwords on <span class="text-transform-none">{{cloudName}}</span>.</h6>
                        <div class="form-floating mb15">
                          <input
                            ref="password"
                            type="password"
                            id="password"
                            placeholder="Type a password"
                            class="form-control fn14"
                            name="password"
                            v-model="password"
                            v-validate="{required:true, regex: $store.state.passwordRegex}"
                          />
                          <label for="password">Type a password</label>
                          <small class="col_error" v-show="errors.has('password')">{{ errors.first('password') }}</small>
                        </div>
                        <div class="form-floating mb15">
                          <input
                            type="password"
                            id="confirmPassword"
                            placeholder="Confirm Password"
                            class="form-control fn14"
                            name="confirmPassword"
                            v-model="confirmPassword"
                            v-validate="{required:true, confirmed: password}"
                          />
                          <label for="confirmPassword">Confirm Password</label>
                          <small class="col_error" v-show="errors.has('confirmPassword')">{{ errors.first('confirmPassword') }}</small>
                        </div>
                        <!-- <v-text-field
                          ref="password"
                          label="Type a password"
                          v-model="password"
                          type="password"
                          v-on:click="formatErrors()"
                          v-on:focusout="formatErrors()"
                          :error-messages="showError">
                        </v-text-field>

                        <v-text-field
                          label="Confirm Password"
                          v-model="confirmPassword"
                          type="password"
                          data-vv-name="password"
                          data-vv-validate-on="input|update|change|blur"
                          v-validate="{required:true, confirmed:password, regex: $store.state.passwordRegex}"
                          :error-messages="errors.collect('password')">
                        </v-text-field> -->
                      </div>
                      <v-card-actions class="pl0">
                        <button class="btn btn-apiculus-primary mr-2" :disabled="!(fields.password && fields.password.valid && confirmPassword === password)" @click="setPassword">DONE</button>
                        <router-link class="col_primary" to="/">CANCEL</router-link>  
                      </v-card-actions>
                    </div>
            
                  <!-- </v-card> -->
                <!-- </v-flex> -->
              </v-layout>
        </div>
      </div>
    </template>
  </Layout1>
  
</template>

<script>
import VueRecaptcha from 'vue-recaptcha'
import Layout1 from './New/Layout1.vue'
import helpers from '../services/toast-service'
import crypto from 'crypto';
export default {
  name: 'account-recovery',
  mixins: [helpers],
  data: () => ({
    form: {
      'g-recaptcha-response': '',
      email: ''
    },
    color: '',
    full_screen: '',
    message: '',
    navLogo: '',
    bannerAsset: '',
    showVerifyEmail: true,
    showEmailOTP: false,
    showMobileOtp: false,
    showSetPassword: false,
    emailOtp: '',
    mobileOtp: '',
    password: '',
    confirmPassword: '',
    cloudName: '',
    rotation: JSON.parse(localStorage.getItem('ApiculusEnv')).passwords.passwordRestrict,
    mobileNo: '',
    countryCode: '',
    showError: [],
    publicKey: '',
    passwordEncryptionOnLogin: ''
  }),
  computed: {
    siteKey () {
      return JSON.parse(localStorage.getItem('ApiculusEnv')).siteKey
    }
  },
  components: { 
    VueRecaptcha,
    Layout1 
  },
  methods: {
    formatErrors () {
      if (this.$store.state.passwordRegex.test(this.password)) {
        this.showError = ''
      } else {
        this.showError = "The password format is invalid."
      }
    },
    sendVerificationLink () {
      this.$store.dispatch('ACTION_VERIFY_RECOVERY_EMAIL', { ...this.form }).then(res => {
        if (!res.success) {
          this.toastAlert(res.error.message || 'Something went wrong, Please try again later.', 'error')
          this.form['g-recaptcha-response'] = ''
          this.$refs.recaptcha.reset()
        } else {
          this.toastAlert('OTP sent successfully', 'success')
          this.showVerifyEmail = false
          this.showEmailOTP = true
        }
      })
    },
    validateEmailOTP () {
      this.$store.dispatch('ACTION_VERIFY_RECOVERY_EMAIL_OTP', { email: this.form.email, otptype: 'email', otp: this.emailOtp}).then(res => {
        if (!res.success) {
          this.toastAlert(res.message || (res.error && res.error.message) || 'Something went wrong, Please try again later.', 'error')
        } else {
          this.showEmailOTP = false
          if (JSON.parse(localStorage.getItem('ApiculusEnv')).passwords.accRecoveryType === 'email_and_mobile') {
            this.showMobileOtp = true
            this.mobileNo = (res.mobile + '').replace(/.(?=.{4,}$)/g, '#');
            this.countryCode = res.c_code;
          } else {
            this.showSetPassword = true
          }
          this.toastAlert('OTP verified successfully', 'success')
        }
      })
    },
    validateMobileOTP () {
      this.$store.dispatch('ACTION_VERIFY_RECOVERY_EMAIL_OTP', { email: this.form.email, otptype: 'mobile', otp: this.mobileOtp }).then(res => {
        if (!res.success) {
          this.toastAlert(res.message || (res.error && res.error.message) || 'Something went wrong, Please try again later.', 'error')
        } else {
          this.toastAlert('OTP verified successfully.', 'success')
          this.showMobileOtp = false
          this.showSetPassword = true
        }
      })
    },
    setPassword () {
      const encryptedPassword = crypto.publicEncrypt(this.publicKey,
        Buffer.from(this.password, 'utf-8')
      )
      const encryptedConfirmPassword = crypto.publicEncrypt(this.publicKey,
        Buffer.from(this.confirmPassword, 'utf-8')
      )
      this.$store.dispatch('ACTION_RECOVERY_ACCOUNT', { email: this.form.email, password: this.passwordEncryptionOnLogin ? encryptedPassword : this.password , confirmPassword: this.passwordEncryptionOnLogin ? encryptedConfirmPassword : this.confirmPassword }).then(res => {
        if (!res.success) {
          this.toastAlert(res.message || (res.error && res.error.message) || 'Something went wrong, Please try again later.', 'error')
        } else {
          this.toastAlert("Password set Successfully!", 'success')
          setTimeout(() => {
            this.$router.push('/')
          }, 3000)
        }
      })
    },
    onCaptchaVerified (res) {
      this.form['g-recaptcha-response'] = res
    },
    onCaptchaExpired (res) {
      this.form['g-recaptcha-response'] = ''
      this.$refs.recaptcha.reset()
    }
  },
  created () {
    this.publicKey = this.$store.state.ApiculusEnv.publicKey.replace(/ /g, '').replace('BEGINPUBLICKEY', 'BEGIN PUBLIC KEY').replace('ENDPUBLICKEY', 'END PUBLIC KEY')
    this.passwordEncryptionOnLogin = this.$store.state.ApiculusEnv.features.passwordEncryptionOnLogin
    this.$store.dispatch('ACTION_GET_PROFILE_DETAILS').then(res => {
      if (res) {
        this.cloudName = res.name
      }
    })
  }
}
</script>

<style lang="scss">
 .bannerElement {
    background-position: center center;
    background-repeat: no-repeat;
    background-size: cover;
    display: flex;
    justify-content: center;
  }

  .container{
    width: 100%;
    margin-bottom: 90%;
  }
  .height-adjust {
    max-height: 80px;
    max-width: 160px;
  }

  .emailText {
    padding-bottom: 5px;
  }
</style>
